<template>
  <div class="color-select">
    <div class="color-select__label text-color-silver mb-05 text--uppercase text--xs-small text--medium">{{ label }}</div>
    <div class="color-select__container">
      <div
        class="color-select__item"
        v-for="(color, index) of computedColors"
        :style="`background-color: ${color.value}`"
        @click="setColor(color)"
        :key="color.value + index"
        :class="{ 'color-select__item--active': color.active }"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: 'Color'
    },

    value: {
      type: [String, Object],
      default: '#000000'
    },

    valueField: {
      type: String,
      default: 'value'
    },

    values: {
      type: Array,
      default: () => ['#000000', '#CCCCCC']
    }
  },

  computed: {
    computedColors () {
      return this.values.map(v => {
        if (typeof this.value !== 'object') { v = { value: v } }
        v.active = (typeof this.value === 'object' && v[this.valueField] === this.value[this.valueField]) || (this.value === v.value)

        return v
      })
    }
  },

  methods: {
    setColor (val) {
      if (typeof this.value === 'object') {
        this.$emit('input', val)
      } else {
        this.$emit('input', val.value)
      }
    }
  }
}
</script>

<style lang="scss">
  .color-select {
    &__container {
      display: flex;
    }

    &__item {
      width: 4rem;
      height: 4rem;
      border-radius: 50%;
      border: 2px solid transparent;
      cursor: pointer;

      &--active {
        border-color: lighten($color-gold, 10%);
        box-shadow: $elevation;
      }

      &:not(:last-child) {
        margin-right: 1rem;
      }
    }
  }
</style>
